// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/complete.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.task {
    padding: 12px 16px;
    background: #FFFFFF;
    border-bottom: 0.5px solid #E5E5EA;
    transition: all 0.2s ease;
}

.task:last-child {
    border-bottom: none;
}

.task:hover:not(.task--open) {
    background: #FAFAFA;
}

.task--open {
    background: #F9F9FB;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04);
    border-bottom: 0.5px solid #E5E5EA;
}


.task_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    user-select: none;
}

.task--checked {
    opacity: 0.6;
}

.task_checkbox {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border: 2px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.task_checkbox:hover {
    border-color: #f90;
}

.task_checkbox--checked {
    background-color: #f90;
    border-color: #f90;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 12px;
    background-position: center;
    background-repeat: no-repeat;
}

.task_name--checked {
    text-decoration: line-through;
    opacity: 0.7;
}

.task_left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
}

.task_check {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    display: none;
}

.task_check--checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 15px;
    background-position: center;
    background-repeat: no-repeat;
}
                                                                                          
.task_name {
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #1D1D1F;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
}

.task_session_icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    opacity: 0.6;
}

.task_datetime {
    font-size: 11px;
    color: #86868B;
    white-space: nowrap;
    flex-shrink: 0;
    font-weight: 400;
}

.task_head_actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.task_metadata_row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
    flex-wrap: wrap;
}

.task_tags {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    align-items: center;
}

.task_tag {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 8px;
    background: #E8F0FF;
    border-radius: 6px;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    color: #007AFF;
    flex-shrink: 0;
}
                                
.task_label {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 8px;
    background: #E8F0FF;
    border-radius: 6px;
    border: 0.5px solid #D1D1D6;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    color: #007AFF;
    flex-shrink: 0;
}

.task_label--tips {
    background: #E8F0FF;
    color: #007AFF;
}

.task_label--file {
    background: #F5F5F7;
    color: #86868B;
}
                                    
.dashboard_main_block_open_button {

}
                                                                           
.task_more {
    padding: 12px 0px 8px 0px;
    position: relative;
    border-top: 0.5px solid #F5F5F7;
    margin-top: 8px;
}

.task_more_text {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: #3C3C43;
}

.task_edit_form {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.task_edit_title {
    width: 100%;
    padding: 8px 12px;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    color: #1D1D1F;
    outline: none;
    transition: all 0.2s ease;
    background: #F9F9FB;
}

.task_edit_title:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.task_edit_text {
    width: 100%;
    padding: 8px 12px;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 13px;
    color: #1D1D1F;
    outline: none;
    resize: vertical;
    min-height: 60px;
    font-family: inherit;
    transition: all 0.2s ease;
    background: #F9F9FB;
}

.task_edit_text:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.task_edit_tags_group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.task_edit_tags_list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    min-height: 24px;
}

.task_edit_tag {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background: #E8F0FF;
    border-radius: 6px;
    font-size: 11px;
    color: #007AFF;
    font-weight: 500;
}

.task_edit_tag_remove {
    background: none;
    border: none;
    color: #007AFF;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    padding: 0 2px;
    margin-left: 2px;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.task_edit_tag_remove:hover {
    opacity: 1;
}

.task_edit_tag_input_group {
    display: flex;
    gap: 4px;
}

.task_edit_tag_input {
    flex: 1;
    padding: 6px 10px;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 12px;
    color: #1D1D1F;
    outline: none;
    transition: all 0.2s ease;
    background: #F9F9FB;
}

.task_edit_tag_input:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.task_edit_tag_add_btn {
    padding: 6px 12px;
    background: #007AFF;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.task_edit_tag_add_btn:hover {
    background: #0051D5;
}

.task_edit_datetime_group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.task_edit_datetime_checkbox_label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #1D1D1F;
    cursor: pointer;
}

.task_edit_datetime_checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.task_edit_label {
    font-size: 11px;
    font-weight: 500;
    color: #1D1D1F;
}

.task_edit_datetime {
    width: 100%;
    padding: 8px 12px;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 13px;
    color: #1D1D1F;
    outline: none;
    transition: all 0.2s ease;
    background: #F9F9FB;
}

.task_edit_datetime:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.task_edit_client_group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.task_edit_session_group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.task_edit_session_select {
    width: 100%;
    padding: 8px 12px;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 13px;
    color: #1D1D1F;
    outline: none;
    transition: all 0.2s ease;
    background: #F9F9FB;
    cursor: pointer;
}

.task_edit_session_select:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.task_edit_loading {
    font-size: 12px;
    color: #86868B;
    padding: 8px 0;
}

.task_edit_no_sessions {
    font-size: 12px;
    color: #86868B;
    padding: 8px 0;
}

.task_edit_actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 4px;
}

.task_edit_save {
    padding: 7px 16px;
    background: #007AFF;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.task_edit_save:hover {
    background: #0051D5;
}

.task_edit_cancel {
    padding: 7px 16px;
    background: #F5F5F7;
    color: #1D1D1F;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.task_edit_cancel:hover {
    background: #EBEBED;
}

.task_edit_delete {
    padding: 7px 12px;
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.2s ease;
    margin-left: auto;
}

.task_edit_delete:hover {
    background: #F5F5F7;
}

.task_delete_icon {
    display: block;
    width: 16px;
    height: 16px;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.task_edit_delete:hover .task_delete_icon {
    opacity: 1;
}

.task_confirm_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.task_confirm_dialog {
    background: white;
    border-radius: 8px;
    padding: 24px;
    min-width: 300px;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.task_confirm_message {
    font-size: 13px;
    color: #1D1D1F;
    margin-bottom: 20px;
    text-align: center;
    line-height: 1.5;
    font-weight: 500;
}

.task_confirm_actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.task_confirm_cancel {
    padding: 8px 20px;
    background: #F5F5F7;
    color: #1D1D1F;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.task_confirm_cancel:hover {
    background: #EBEBED;
}

.task_confirm_delete {
    padding: 8px 20px;
    background: #FF3B30;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.task_confirm_delete:hover {
    background: #D93025;
}

.task--closed .task_more {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/task/Task.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;AACtC;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yDAAwL;IACxL,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yDAAwD;IACxD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;AAEA;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["\n.task {\n    padding: 12px 16px;\n    background: #FFFFFF;\n    border-bottom: 0.5px solid #E5E5EA;\n    transition: all 0.2s ease;\n}\n\n.task:last-child {\n    border-bottom: none;\n}\n\n.task:hover:not(.task--open) {\n    background: #FAFAFA;\n}\n\n.task--open {\n    background: #F9F9FB;\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04);\n    border-bottom: 0.5px solid #E5E5EA;\n}\n\n\n.task_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.task--checked {\n    opacity: 0.6;\n}\n\n.task_checkbox {\n    width: 18px;\n    height: 18px;\n    min-width: 18px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.task_checkbox:hover {\n    border-color: #f90;\n}\n\n.task_checkbox--checked {\n    background-color: #f90;\n    border-color: #f90;\n    background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"white\"><path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"/></svg>');\n    background-size: 12px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.task_name--checked {\n    text-decoration: line-through;\n    opacity: 0.7;\n}\n\n.task_left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n    min-width: 0;\n}\n\n.task_check {\n    width: 12px;\n    height: 12px;\n    flex-shrink: 0;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    display: none;\n}\n\n.task_check--checked {\n    background-image: url('../../../../assets/complete.svg');\n    background-size: 15px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n                                                                                          \n.task_name {\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 20px;\n    color: #1D1D1F;\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.task_session_icon {\n    width: 14px;\n    height: 14px;\n    flex-shrink: 0;\n    opacity: 0.6;\n}\n\n.task_datetime {\n    font-size: 11px;\n    color: #86868B;\n    white-space: nowrap;\n    flex-shrink: 0;\n    font-weight: 400;\n}\n\n.task_head_actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.task_metadata_row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 6px;\n    flex-wrap: wrap;\n}\n\n.task_tags {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.task_tag {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 8px;\n    background: #E8F0FF;\n    border-radius: 6px;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 12px;\n    text-align: center;\n    color: #007AFF;\n    flex-shrink: 0;\n}\n                                \n.task_label {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 8px;\n    background: #E8F0FF;\n    border-radius: 6px;\n    border: 0.5px solid #D1D1D6;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 12px;\n    text-align: center;\n    color: #007AFF;\n    flex-shrink: 0;\n}\n\n.task_label--tips {\n    background: #E8F0FF;\n    color: #007AFF;\n}\n\n.task_label--file {\n    background: #F5F5F7;\n    color: #86868B;\n}\n                                    \n.dashboard_main_block_open_button {\n\n}\n                                                                           \n.task_more {\n    padding: 12px 0px 8px 0px;\n    position: relative;\n    border-top: 0.5px solid #F5F5F7;\n    margin-top: 8px;\n}\n\n.task_more_text {\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 18px;\n    color: #3C3C43;\n}\n\n.task_edit_form {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.task_edit_title {\n    width: 100%;\n    padding: 8px 12px;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #1D1D1F;\n    outline: none;\n    transition: all 0.2s ease;\n    background: #F9F9FB;\n}\n\n.task_edit_title:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.task_edit_text {\n    width: 100%;\n    padding: 8px 12px;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 13px;\n    color: #1D1D1F;\n    outline: none;\n    resize: vertical;\n    min-height: 60px;\n    font-family: inherit;\n    transition: all 0.2s ease;\n    background: #F9F9FB;\n}\n\n.task_edit_text:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.task_edit_tags_group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.task_edit_tags_list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    min-height: 24px;\n}\n\n.task_edit_tag {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 8px;\n    background: #E8F0FF;\n    border-radius: 6px;\n    font-size: 11px;\n    color: #007AFF;\n    font-weight: 500;\n}\n\n.task_edit_tag_remove {\n    background: none;\n    border: none;\n    color: #007AFF;\n    font-size: 16px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 2px;\n    margin-left: 2px;\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n}\n\n.task_edit_tag_remove:hover {\n    opacity: 1;\n}\n\n.task_edit_tag_input_group {\n    display: flex;\n    gap: 4px;\n}\n\n.task_edit_tag_input {\n    flex: 1;\n    padding: 6px 10px;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 12px;\n    color: #1D1D1F;\n    outline: none;\n    transition: all 0.2s ease;\n    background: #F9F9FB;\n}\n\n.task_edit_tag_input:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.task_edit_tag_add_btn {\n    padding: 6px 12px;\n    background: #007AFF;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.task_edit_tag_add_btn:hover {\n    background: #0051D5;\n}\n\n.task_edit_datetime_group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.task_edit_datetime_checkbox_label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: #1D1D1F;\n    cursor: pointer;\n}\n\n.task_edit_datetime_checkbox {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n}\n\n.task_edit_label {\n    font-size: 11px;\n    font-weight: 500;\n    color: #1D1D1F;\n}\n\n.task_edit_datetime {\n    width: 100%;\n    padding: 8px 12px;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 13px;\n    color: #1D1D1F;\n    outline: none;\n    transition: all 0.2s ease;\n    background: #F9F9FB;\n}\n\n.task_edit_datetime:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.task_edit_client_group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.task_edit_session_group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.task_edit_session_select {\n    width: 100%;\n    padding: 8px 12px;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 13px;\n    color: #1D1D1F;\n    outline: none;\n    transition: all 0.2s ease;\n    background: #F9F9FB;\n    cursor: pointer;\n}\n\n.task_edit_session_select:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.task_edit_loading {\n    font-size: 12px;\n    color: #86868B;\n    padding: 8px 0;\n}\n\n.task_edit_no_sessions {\n    font-size: 12px;\n    color: #86868B;\n    padding: 8px 0;\n}\n\n.task_edit_actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n    margin-top: 4px;\n}\n\n.task_edit_save {\n    padding: 7px 16px;\n    background: #007AFF;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.task_edit_save:hover {\n    background: #0051D5;\n}\n\n.task_edit_cancel {\n    padding: 7px 16px;\n    background: #F5F5F7;\n    color: #1D1D1F;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.task_edit_cancel:hover {\n    background: #EBEBED;\n}\n\n.task_edit_delete {\n    padding: 7px 12px;\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    margin-left: auto;\n}\n\n.task_edit_delete:hover {\n    background: #F5F5F7;\n}\n\n.task_delete_icon {\n    display: block;\n    width: 16px;\n    height: 16px;\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n}\n\n.task_edit_delete:hover .task_delete_icon {\n    opacity: 1;\n}\n\n.task_confirm_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n}\n\n.task_confirm_dialog {\n    background: white;\n    border-radius: 8px;\n    padding: 24px;\n    min-width: 300px;\n    max-width: 400px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n.task_confirm_message {\n    font-size: 13px;\n    color: #1D1D1F;\n    margin-bottom: 20px;\n    text-align: center;\n    line-height: 1.5;\n    font-weight: 500;\n}\n\n.task_confirm_actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.task_confirm_cancel {\n    padding: 8px 20px;\n    background: #F5F5F7;\n    color: #1D1D1F;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.task_confirm_cancel:hover {\n    background: #EBEBED;\n}\n\n.task_confirm_delete {\n    padding: 8px 20px;\n    background: #FF3B30;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.task_confirm_delete:hover {\n    background: #D93025;\n}\n\n.task--closed .task_more {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
